/**
 * Action Types
 */
import { type } from '../models/type-cache';
import { AixAction } from '../aix-action';
import { FlashMessage } from './model';

export class FlashMessagesActionTypes {
    static readonly ADD_FLASH_MESSAGE = type('[FlashMessage] Add Flash Message');
    static readonly REMOVE_FLASH_MESSAGE = type('[FlashMessage] Remove Flash Message');
    static readonly CLEAR_FLASH_MESSAGES = type('[FlashMessage] Clear Flash Messages');
}

/**
 * Available Action Types
 */
export type FlashMessagesActions =
    | ClearFlashMessagesAction
    | AddFlashMessageAction
    | RemoveFlashMessageAction;

/**
 * Actions
 */

export class ClearFlashMessagesAction implements AixAction {
    readonly type = FlashMessagesActionTypes.CLEAR_FLASH_MESSAGES;
}

export class AddFlashMessageAction implements AixAction {
    readonly type = FlashMessagesActionTypes.ADD_FLASH_MESSAGE;

    constructor(public payload: { message: FlashMessage }) {}
}

export class RemoveFlashMessageAction implements AixAction {
    readonly type = FlashMessagesActionTypes.REMOVE_FLASH_MESSAGE;

    constructor(public payload: { uid: string }) {}
}
